
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';


import { Link } from "react-router-dom";
import olasz from "../../assets/olasz.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function OlaszMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Olasz magyar fordító</title>
                <meta name='description' content="Ingyenes olasz magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Olasz magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/olasz-magyar-fordito" />
            </Helmet>
            <h1>Olasz magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>Az olasz nyelvről</h2>
                    <img src={olasz} alt="Olasz zászló"></img>
                </div>



                <p>Az olasz egy neo-latin nyelv, amelyet elsősorban Olaszországban beszélnek. Svájc, San Marino, Vatikánváros és az Európai Unió egyik hivatalos nyelve is. Az olasz zeneiségéről, kulturális gazdagságáról és történelmi jelentőségéről ismert, mint a Római Birodalom és a reneszánsz nyelve.</p>

                <p>Az olasz írásrendszer a latin ábécét használja, és 21 betűből áll, köztük öt magánhangzóból (a, e, i, o, u) és mássalhangzók halmazából. Az olasz kiejtés általában fonetikus, néhány kivételtől eltekintve. Minden betűnek konzisztens hangja van, ami viszonylag egyszerűvé teszi az írott szavak kiejtését.</p>

                <p>Az olasz nyelvtan a főnévi nemek (férfi és nőnemű), főnévi ragozások, igeragozások és névelők rendszerét tartalmazza. A főnevek és melléknevek végződését nemnek és számnak megfelelően változtatják, az igék pedig idő, mód, személy és szám szerint ragozódnak. Az olasz szórend általában alany-ige-tárgy, de az igeragozások gazdag rendszerének köszönhetően rugalmas.</p>

                <p>Az olasz szókincs elsősorban latin eredetű, de tartalmaz más nyelvekből származó kölcsönszavakat is, különösen az angol és a francia nyelvből. Az olasz nyelv gazdag művészeti és irodalmi hagyományokkal rendelkezik, olyan szerzők neves műveivel, mint Dante Alighieri, Petrarch és Italo Calvino. Az olasz opera, a klasszikus zene és a mozi is jelentős globális hatást gyakorolt.</p>

                <p>Az olasz kultúra sokszínű, és magában foglalja a művészetet, az építészetet, a divatot, a konyhát és még sok mást. Az olasz nyelv tanulása hozzáférést biztosít Olaszország hatalmas kulturális örökségéhez, beleértve a híres tereptárgyakat, mint a Colosseum, a Vatikán és a velencei csatornák. Az olasz társadalom, szokások és értékek megértését is fejleszti.</p>

                <p>Az olasz nyelvtudás számos lehetőséget kínál. Olaszország virágzó gazdasággal rendelkezik, különösen az olyan iparágakban, mint a divat, a design, az autóipar és a turizmus. Az olasz nyelvtudás előnyt jelenthet ezeken a területeken, vagy azoknak, akik Olaszországban szeretnének dolgozni vagy tanulni.</p>

                <p>Az olasz nyelvet széles körben beszélik a világ számos országában és közösségében, így hasznos az utazáshoz, a kulturális elmélyüléshez és az olasz anyanyelvűekkel való kapcsolatok kiépítéséhez szerte a világon. Ezenkívül Olaszország neves egyetemeknek és kutatóintézeteknek ad otthont, amelyek nemzetközi hallgatókat és tudósokat vonzanak.</p>


                <div className="sectionbottom">
                    <Link to="/magyar-olasz-fordito">Magyar olasz fordító</Link>

                    <img src={olasz} alt="olasz zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>
            </section>
        </>

    )
}

export default OlaszMagyar;